// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"2ad2fdab","646":"7e510627","918":"41d646ae"}[chunkId] + ".chunk.css";
};